import {hitGoogleTagManager} from "../../tracking/google_tag_manager/init_google_tag_manager";

interface IHitMapSearchParams {
    action: "apply" | "open" | "close";
    regionName: string;
    eventName?: string;
}

export function hitMapSearch(params: IHitMapSearchParams) {
    const {action, regionName, eventName} = params;

    hitGoogleTagManager({
        event: eventName || "map_search",
        event_action: action,
        event_category: regionName
    });
}
import {hitGoogleTagManager} from "../../tracking/google_tag_manager/init_google_tag_manager";

interface IHitMapSearchParams {
    action: "apply" | "open" | "close";
    regionName: string;
    eventName?: string;
}

export function hitMapSearch(params: IHitMapSearchParams) {
    const {action, regionName, eventName} = params;

    hitGoogleTagManager({
        event: eventName || "map_search",
        event_action: action,
        event_category: regionName
    });
}
